import { Job, OrganizationProfile } from '~/jobiqo/types/types';
import { Dimensions } from '~/jobiqo/lib/analytics';
import { User } from '~/jobiqo/models/user';

/**
 * Returns the custom dimensions for a given job.
 *
 * Can be used to add custom dimensions to the analytics event for a job.
 *
 * @param {Job} job
 *  The job to return dimensions for.
 * @param {User} user
 *  The current user.
 * @returns {Dimensions}
 *  The custom dimensions object for this job.
 */
export const getCustomJobDimensions = (
  job: Job,
  user: User | null = null,
): Dimensions => {
  return {};
};

/**
 * Returns the custom dimensions for a given organization profile.
 *
 * Can be used to add custom dimensions to the analytics event for an organization profile.
 *
 * @param {OrganizationProfile} organizationProfile
 *  The organization profile to return dimensions for.
 * @returns {Dimensions}
 *  The custom dimensions object for this organization profile.
 */
export const getCustomOrganizationProfileDimensions = (
  organizationProfile: OrganizationProfile,
): Dimensions => {
  return {};
};
